import "./Inquire.module.css";
import Navigation from "@/reusable_sections/Header";
import SecureTheFrame from "./sections/SecureTheFrame";
import FrequentlyAsked from "./sections/FrequentlyAsked";
import FooterArchive from "@/reusable_sections/Footer";
export default function InquirePage() {
  return <div>
      <Navigation />
      <SecureTheFrame />
      <FrequentlyAsked />
      <FooterArchive />
    </div>;
}